<cap-rubrik [isClosable]="false" [isOpen]="true" id="rubrik-grundstueckbeschreibung">
  <ng-container title>
    <h2 class="mb-0">{{ "grundstueck.rubrik.Grundstueckbeschreibung" | translate }}</h2>
  </ng-container>
  @if (gsId.id) {
    <cap-grundstueck-beschreibung
      [gsId]="gsId"
      [hasRight]="
        grundstueckEntry?.permissions?.beschreibung && grundstueckEntry?.permissions?.beschreibungErsterfassungUebergeben
      "></cap-grundstueck-beschreibung>
  }
</cap-rubrik>
